
<template>
    <div>
        <div class="pop-up">
            <el-input type="textarea" :rows="7" placeholder="请输入相关信息，并以换行隔开！" v-model="initValue"></el-input>
        </div>
        <div class="btn_box">
            <button class="btn_canle" @click="closeDialog">取消</button><button class="btn_sure" @click="confirmDialog">确定</button>
        </div>
    </div>
</template>

<script>
import {Input} from 'element-ui';
export default {
    props:['msg'],//子接收父级传来的
    data() {
        return {
            initValue: null,
            flag:''
        }
    },
    watch: {
    },
    mounted() {
        let vm = this;
        vm.flag = vm.msg.flag;
        if(vm.msg.val){
            vm.initValue = vm.msg.val.replace(/,/g,'\n');
        }
    },
    methods: {
        closeDialog(e, bool=false, txt=null) {
            var vm = this;
            vm.$emit('close');
        },
        confirmDialog() {
            var vm = this,txt,params={};
            if(vm.initValue){
                txt = vm.initValue.replace(/\n+/g,',');
                let len = txt.length,
                    char = txt.charAt(len-1);
                if(char == ','){
                    txt = txt.substring(0,len-1);
                }
            }
            params = {
                val:txt,
                flag:vm.flag
            }
            vm.$emit('ok',params);
        }
    },
    components: {'el-input':Input}
};
</script>
<style lang = 'scss' scoped>
.btn_box {
        text-align: center;
        margin-top: 15px;      
    }
    .btn_canle {
            @extend .btnbase;
            color: #2c88f4;
            background-color: #deefff;
        }

        .btn_green {
            @extend .btnbase;
            color: #fff;
            background-color: #67c23a;
        }
     .btn_sure {
         border: 0px;
        font-weight: bold;
        font-size: 12px;
        cursor: pointer;
        display: inline-block;
        height: 33px;
        line-height: 33px;
        margin: 8px 12px;
        width: 70px;
        border-radius: 4px;
            color: #fff;
            background-color: #2c88f4;
        }
         .btnbase {
        border: 0px;
        font-weight: bold;
        font-size: 12px;
        cursor: pointer;
        display: inline-block;
        height: 33px;
        line-height: 33px;
        margin: 8px 12px;
        width: 70px;
        background-color: #deefff;
        border-radius: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/components/textareaDialog.vue